/** Favourite storage key for Survey Data Viewer preconfigured views/recipes. */
export function buildSdmPreconfiguredFavouriteKey(viewId: string): string {
  return `sdm-view::${viewId}`;
}

export function isSdmPreconfiguredFavouriteKey(layerKey: string): boolean {
  return layerKey.replace(/^favourites_/, '').startsWith('sdm-view::');
}

export function parseSdmPreconfiguredFavouriteRecipeId(
  layerKey: string,
): string | null {
  const baseKey = layerKey.replace(/^favourites_/, '');
  if (!baseKey.startsWith('sdm-view::')) {
    return null;
  }
  const recipeId = baseKey.slice('sdm-view::'.length);
  return recipeId.length > 0 ? recipeId : null;
}

export function sdmFavouriteTwinKeys(baseKey: string): readonly [string, string] {
  const normalized = baseKey.replace(/^favourites_/, '');
  return [normalized, `favourites_${normalized}`];
}

export function syncSdmFavouriteCheckedKeys(
  checkedKeys: readonly string[],
  favouriteKeys: readonly string[],
  activeRecipeIds: ReadonlySet<string>,
): string[] {
  const favouriteBaseKeys = [
    ...new Set(
      favouriteKeys
        .map((key) => key.replace(/^favourites_/, ''))
        .filter(isSdmPreconfiguredFavouriteKey),
    ),
  ];

  const next = checkedKeys.filter(
    (key) => !isSdmPreconfiguredFavouriteKey(String(key)),
  );

  for (const baseKey of favouriteBaseKeys) {
    const recipeId = parseSdmPreconfiguredFavouriteRecipeId(baseKey);
    if (!recipeId || !activeRecipeIds.has(recipeId)) {
      continue;
    }
    next.push(...sdmFavouriteTwinKeys(baseKey));
  }

  return [...new Set(next.map(String))];
}

export const SDM_SET_RECIPE_VISIBILITY_EVENT = 'sdm:set-recipe-visibility';

export interface SdmSetRecipeVisibilityDetail {
  readonly recipeId: string;
  readonly visible: boolean;
}

export function dispatchSdmSetRecipeVisibility(
  recipeId: string,
  visible: boolean,
): void {
  const detail: SdmSetRecipeVisibilityDetail = { recipeId, visible };
  window.dispatchEvent(
    new CustomEvent<SdmSetRecipeVisibilityDetail>(SDM_SET_RECIPE_VISIBILITY_EVENT, {
      detail,
    }),
  );
}
